import React from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import { Modal, Button } from 'react-bootstrap';
import 'react-notification-center/src/less/index.less';
import { notificationMarkReadAll, notificationMarkRead } from '@/store/notification.store.js';
import ReactNotificationCenter from 'react-notification-center';
import { cutString } from 'react-notification-center/lib/utils';
import cn from 'classnames';
import Tag from 'react-notification-center/lib/Tag';
import Header from 'react-notification-center/lib/header';
import Content from 'react-notification-center/lib/content';
import Footer from 'react-notification-center/lib/footer';
import NotificationItem from 'react-notification-center/lib/Item';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
moment.locale('en');
momentLocalizer();
import bell from '@/../style/bell.png';

/* eslint-disable */
class CustomNotificationItem extends NotificationItem {

  render() {
    return (
      <li
        className={cn('rn-item', { new: this.props[this.props.options.new] })}
        onClick={this.handleOnClick.bind(this)}
      >
        <p className="short-desc">
          {this.props.tags && this.props.tags.map((item, i) => <Tag key={i} {...item}>{item.text}</Tag>)}
          {this.props[this.props.options.title] && <strong className="title">
            {this.props[this.props.options.title]} </strong>}
          {this.props[this.props.options.message] && this.props[this.props.options.message]}
          {this.props[this.props.options.date] && <small className="date">
            {this.props[this.props.options.date]}</small>}
        </p>
      </li>
    );
  }
}

class ReactNotifications extends ReactNotificationCenter {

  componentWillReceiveProps(nextProps) {
    super.componentWillReceiveProps(nextProps);
    if ((nextProps.notifications.length === this.state.notifications.length)
      && (nextProps.notifications != this.state.notifications)) {
      this.setState({ notifications: nextProps.notifications });
    }
  }

  render() {
    return (
      <div className={cn('react-notification-center', 'light-theme', { hide: !this.props.visible })}>
        <div className={cn('r-notifications-icon', { active: this.getUnreadLength() })} ref="notificationIcon">
          <img src={bell} alt={'notifications'} />
          {this.getUnreadLength() > 0 && <span className={'react-notification-unread-count'}>
            <span className={'react-notification-unread-count-number'}>{this.getUnreadLength()}
            </span>
          </span>}
        </div>
        {this.state.showNotification &&
        <div className={cn('rr-wrapper', this.props.position)} ref="notificationHolder">
          <div className="notification-holder">
            <div className="r-notifications">
              <Header>{cutString(this.props.notificationTitle, 30)}</Header>
              <Content {...this.props}>
                {this.state.notifications.length == 0 &&
                <div className="no-rn">{this.props.noNotificationText}</div>
                }
                <ul className="rn-ul">
                  {this.state.notifications.map((item, i) => (
                    <CustomNotificationItem
                      key={i}
                      options={this.mapOptions()}
                      {...item}
                    />
                    ))}
                </ul>
              </Content>
              <Footer />
            </div>

            <div className={cn('r-notification', { active: this.state.showNotificationMessage })}>
              <Header>{this.state.current && this.state.current[this.mapOptions().title]}</Header>
              <Content {...this.props}>
                <div className="desc">
                  {this.state.current && this.state.current[this.mapOptions().message]}
                </div>
              </Content>
              <Footer>
                <button type="button" onClick={this.back.bind(this)}>
                  <div className="back" />
                </button>
              </Footer>
            </div>
          </div>
        </div>}
      </div>
    );
  }
}
/* eslint-enable */

const localDateTimeToString = d =>
  moment(`${d.get('dayOfMonth')}.${d.get('monthValue')}.${d.get('year')} ${d.get('hour')}
  :${d.get('minute')}`, 'DD.MM.YYYY hh:mm').format('DD MMM YYYY, HH:mm');

class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.initNotifications = this.initNotifications.bind(this);
    this.markRead = this.markRead.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.renderModalNotifications = this.renderModalNotifications.bind(this);
    this.mapNotification = this.mapNotification.bind(this);
    this.state = { notifications: [], wasOpened: false, wsNotifications: [] };
  }

  componentWillMount() {
    this.initNotifications();
  }

  componentWillReceiveProps(props) {
    if (this.props.notifications.size != props.notifications.size
      || !this.props.notifications.equals(props.notifications)) {
      this.initNotifications(props);
    }
  }

  mapNotification(n) {
    return {
      id: n.get('id'),
      title: this.titleFormatter(n),
      message: this.messageFormatter(n),
      new: !n.get('read'),
      date: localDateTimeToString(n.get('creationTime')),
      ws: n.get('ws'),
    };
  }

  /* eslint-disable */
  titleFormatter(n) {
    const header = `${n.get('header')}.`;
    return ( <span dangerouslySetInnerHTML={{__html: header}}/>);
  }


  messageFormatter(n) {
    const message = n.get('text');
    return ( <span dangerouslySetInnerHTML={{__html: message}}/>);
  }
  /* eslint-enable */
  initNotifications(props = this.props) {
    this.setState({ notifications: props.notifications.map(this.mapNotification).toJS(),
      wsNotifications: props.notifications.filter(n => n.get('ws') && !n.get('read'))
        .map(this.mapNotification).toJS(),
    });
  }

  markRead() {
    if (!this.state.wasOpened) {
      this.props.markReadAll();
      this.setState({ wasOpened: true });
    }
  }

  hideModal() {
    this.props.markRead(this.state.wsNotifications.map(n => n.id));
    this.setState({ wsNotifications: [] });
  }

  renderModalNotifications() {
    return (
      <div>
        {this.state.wsNotifications.map(n => (
          <div style={{ borderBottom: 'thin solid #e5e5e5', paddingTop: '10px', fontSize: '13px' }}>
            <span><b>{n.title} </b></span>
            <span>{n.message}</span>
            <div style={{ color: '#999' }}>{n.date}</div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    return (
      <div style={{ color: 'black' }}>
        <Modal
          show={!!this.state.wsNotifications.length}
          onHide={this.hideModal}
        >
          <Modal.Header style={{ padding: '5px' }}>
            <div style={{ fontSize: '15px', paddingLeft: '15px' }}>New notifications</div>
          </Modal.Header>
          <Modal.Body>
            <div style={{ maxHeight: '50vh', overflowY: 'auto', overflowX: 'hidden' }}>
              {this.renderModalNotifications()}
            </div>
          </Modal.Body>
          <Modal.Footer style={{ padding: '10px' }}>
            <Button
              onClick={this.hideModal}
              style={{ width: '71px', height: '30px', padding: '2px 6px' }}
            >Close</Button>
          </Modal.Footer>
        </Modal>
        <ReactNotifications
          notifications={this.state.notifications}
          notificationTitle="Notifications"
          onNotificationOpen={this.markRead}
          noNotificationText="You have no notifications"
          position="notification-list-position"
          visible
        />
      </div>

    );
  }
}

Notifications.propTypes = {
  notifications: React.PropTypes.object,
  markRead: React.PropTypes.func,
  markReadAll: React.PropTypes.func,
};

export default connect(
  state => ({
    notifications: state.getIn(['notifications', 'notifications'], new List()),
  }),
  dispatch => ({
    markReadAll() {
      notificationMarkReadAll(dispatch);
    },
    markRead(ids) {
      notificationMarkRead(dispatch, ids);
    },
  }))(Notifications);
